import styled from 'styled-components';

export const InputWrapper = styled.div`
    min-width: 77px;
    max-width: 800px;
    margin-right: 10px;
    position: relative;
`;
